import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {illustration, contactInfo, backgroudProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  return (

      <div className="main contact-margin-top" style={{padding:0}} id="contact">
        
      <div className="contant-hierarcy">
        <div className="contact-main-new">
          <div className="contact-background">
            <div className="contact-background-frames">
              <section className="contact-section">
                <ul className="contact-ul">
                  {[...backgroudProjects.sliderone, ...backgroudProjects.sliderone].map((brands, i) => {
                    return (
                <li style={{width:"100%"}}>
                    <div className="contact-li-one">
                      <div className="contact-li-two">
                        <img decoding="async" width="2400" height="2880" sizes="1200px" style={{display:"block",width:"100%",height:"100%",borderRadius:"inherit",objectPosition:"center center",objectFit:"cover"}} src={brands.projectImg}>
                        </img>
                      </div>
                    </div>
                  </li>
                  );
                })}
                </ul>
              </section>
            </div>
            <div className="contact-background-frames">
              <section className="contact-section">
                <ul className="contact-ul-two">
                  {[...backgroudProjects.slidertwo, ...backgroudProjects.slidertwo].map((brands, i) => {
                    return (
                <li style={{width:"100%"}}>
                    <div className="contact-li-one">
                      <div className="contact-li-two">
                        <img decoding="async" width="2400" height="2880" sizes="1200px" style={{display:"block",width:"100%",height:"100%",borderRadius:"inherit",objectPosition:"center center",objectFit:"cover"}} src={brands.projectImg}>
                        </img>
                      </div>
                    </div>
                  </li>
                  
                  );
                })}               
                </ul>
              </section>
            </div>
            <div className="contact-background-frames">
              <section className="contact-section">
                <ul className="contact-ul">
                  {[...backgroudProjects.sliderthree, ...backgroudProjects.sliderthree].map((brands, i) => {
                    return (
                <li style={{width:"100%"}}>
                    <div className="contact-li-one">
                      <div className="contact-li-two">
                        <img decoding="async" width="2400" height="2880" sizes="1200px" style={{display:"block",width:"100%",height:"100%",borderRadius:"inherit",objectPosition:"center center",objectFit:"cover"}} src={brands.projectImg}>
                        </img>
                      </div>
                    </div>
                  </li>
                  );
                })}
                </ul>
              </section>
            </div>
          </div>
          <div className="contact-content">
              <div className="contact-blackgradient"></div>
                <div style={{position:"relative"}}>
                  <div className="contact-div-main">
                    <div className="contact-header">
                      <p className="contact-big-text" style={{marginTop:"50px",marginBottom:"20px"}}>
                        <span>
                          <img className="img-contactme-smol" style={{marginRight:"20px",filter: "brightness(0) invert(1)",rotate:"352deg"}} src={require("../../assets/images/email.webp")}></img> 
                        </span>
                        Got an idea
                        <span>
                          <img className="img-contactme-smol" style={{filter: "brightness(0) invert(1)"}} src={require("../../assets/images/question-sign.png")}></img> 
                        </span>
                      </p>
                      <p className="contact-big-text" style={{marginTop:"25px",marginBottom:"30px"}}>
                        <span>
                          <img className="img-contactme-smol-empty" style={{visibility:"hidden"}} src={require("../../assets/images/email.webp")}></img> 
                        </span>
                        Open to Work together
                      </p>
                      
              
              <div className="contact-title">
                <div className="contact-socialmedia">
                  <p className="contact-sayhello">SAY HELLO</p>
                  <SocialMedia />
                </div>
                <div className="contact-div-btn">
                  <p className="contact-contactme-desc">Ready for exciting new opportunities and collaborations — whether you need a reliable developer or someone to help shape your next digital product, feel free to get in touch.</p>
                  <div style={{display:"flex"}}>
                    <div className="contact-btn-boundaries"></div>
                    <div className="contact-btn-outer">
                      <a href={`mailto:${contactInfo.email_address}`} className="contact-btn-outer-a">
                        <div className="contact-btn-inner">
                          <p style={{fontSize: "24px",fontFamily: "DegularBold",color:"#000"}}>Drop a message</p>
                        </div>
                      </a>
                    </div>
                    <div className="contact-btn-boundaries"></div>
                  </div>
                </div>
              </div>
              <div className="contact-div-btn">
                <p className="contact-detail-label">Available for Job Opportunities:</p>
                <a
                  className="contact-detail"
                  href={"tel:" + contactInfo.number}
                >
                  {contactInfo.number}
                </a>
              </div>
            </div>
          </div>
          
        </div>
                
              </div>
          </div>
        </div>
      </div>
      

  );
}
